import React, { createContext, useContext, useState } from 'react';
import { oneSignalInit } from '../../utils/onesignal/init';

// Create the OneSignal Context
const OneSignalContext = createContext({
  isInitialized: false,
});

// Provider Component
export const OneSignalProvider = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  React.useEffect(() => {

    oneSignalInit();
    setIsInitialized(true);


  }, []);


  return (
    <OneSignalContext.Provider value={{ isInitialized }}>
      {children}
    </OneSignalContext.Provider>
  );
};

// Hook for easy use
export const useOneSignal = () => useContext(OneSignalContext);
